export default __webpack_public_path__ + "static/media/MB_Logo.96fbb3af.svg";